"use strict";

module.exports = {
  QUALITY_REQUESTED: 'qualityRequested',
  QUALITY_SELECTED: 'qualitySelected',
  PLAYER_SOURCES_CHANGED: 'playerSourcesChanged'
};